module.exports = __webpack_public_path__ + "img/team.e4bde87c.png";